import { isStandalone, isSafari } from './browser.js';
import { mainWindow } from './window.js';
import { isNative } from '../common/platform.js';
const BrowserFeatures = {
    clipboard: {
        writeText: (isNative
            || (document.queryCommandSupported && document.queryCommandSupported('copy'))
            || !!(navigator && navigator.clipboard && navigator.clipboard.writeText)),
        readText: (isNative
            || !!(navigator && navigator.clipboard && navigator.clipboard.readText))
    },
    keyboard: (() => {
        if (isNative || isStandalone()) {
            return 0 ;
        }
        if (navigator.keyboard || isSafari) {
            return 1 ;
        }
        return 2 ;
    })(),
    touch: 'ontouchstart' in mainWindow || navigator.maxTouchPoints > 0,
    pointerEvents: mainWindow.PointerEvent && ('ontouchstart' in mainWindow || navigator.maxTouchPoints > 0)
};
export { BrowserFeatures };
